import {
  AvailableReturnPosition,
  OrderPreview,
  PortalOrderStatus,
  ProposeOrderPostDto
} from '@/types/index'

const ORDER_NUMBER_MAX_LENGTH = 250
const CHECKOUT_SESSION_TIME_MILLISECONDS = 300000

type OrderPreviewColumns = {
  ARRIVED: OrderPreviewColumn
  PROCESSING: OrderPreviewColumn
  ADVISED: OrderPreviewColumn
  INVOICED: OrderPreviewColumn
  ERROR: OrderPreviewColumn
}

type OrderPreviewColumnsKey = keyof OrderPreviewColumns

type OrderPreviewColumn = {
  orderStatus: PortalOrderStatus
  orderPreviews: OrderPreview[]
  count: number
  pages: number
  loading: boolean
  loadingNextPage: boolean
}

type PreparedOrder = Omit<ProposeOrderPostDto, 'timestamp'>

enum SortDirection {
  ASC,
  DESC,
  NONE
}

enum OrdersView {
  LIST = 'LIST',
  GRID = 'GRID',
  APPROVALS = 'APPROVALS'
}

type OrderRmaReturnPosition = AvailableReturnPosition & {
  selected: boolean
  quantity: number
  reason?: string
  positionNumber: number
}

enum RmaStep {
  SELECT_POSITION,
  SELECT_REASON
}

export {
  CHECKOUT_SESSION_TIME_MILLISECONDS,
  ORDER_NUMBER_MAX_LENGTH,
  OrderPreviewColumn,
  OrderPreviewColumns,
  OrderPreviewColumnsKey,
  OrderRmaReturnPosition,
  OrdersView,
  PreparedOrder,
  RmaStep,
  SortDirection
}
